import React from "react";
import ReactDOM from "react-dom";
import DropdownOption from "./DropdownOption";
import DropdownOptionsValue from "./DropdownOptionsValue";

class DropdownOptionsList extends React.Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    document.addEventListener("click", this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
    document.removeEventListener("click", this.handleClick, false);
  }

  handleKeyDown = (event) => {
    const ESCAPE_KEY = 27;
    if (event.keyCode === ESCAPE_KEY) {
      this.props.closeDropdown();
    }
  };

  handleClick = (event) => {
    if (!ReactDOM.findDOMNode(this).contains(event.target)) {
      this.props.closeDropdown();
    }
  };

  render() {
    const optionsList = this.props.options.map((val) => {
      return (
        <DropdownOption
          key={val}
          value={val}
          selectOption={this.props.selectOption}
        />
      );
    });

    return (
      <div className="dropdown__select">
        <ul className="dropdown__options">
          <DropdownOptionsValue
            value={this.props.value}
            handleClick={this.props.handleClick}
          />
          {optionsList}
        </ul>
      </div>
    );
  }
}

export default DropdownOptionsList;
